import { GetTransactionsResponse } from "../types/transactions";

/**
 * Replace the transaction with the same id, or append it when absent. Pure, so
 * it is safe inside a (StrictMode double-invoked) setState updater.
 */
export function upsertTransactionInList(
  list: GetTransactionsResponse[],
  transaction: GetTransactionsResponse,
): GetTransactionsResponse[] {
  const id = transaction.transaction.id;
  let found = false;
  const next = list.map((t) => {
    if (t.transaction.id !== id) return t;
    found = true;
    return transaction;
  });
  return found ? next : [...list, transaction];
}

/**
 * The single calendar transaction lookup. TransactionContext's list is the one
 * store every write path (local edits, drag, Pusher/sync refetch) upserts into,
 * so it wins; the modal's selectedTransaction is only a fallback for a
 * transaction that was opened without being in the fetched range (timeline,
 * rebook "view new appointment").
 */
export function findTransactionById(
  transactionId: string,
  transactions: readonly GetTransactionsResponse[],
  selectedTransaction: GetTransactionsResponse | null,
): GetTransactionsResponse | undefined {
  return (
    transactions.find((t) => t.transaction.id === transactionId) ??
    (selectedTransaction?.transaction.id === transactionId
      ? selectedTransaction
      : undefined)
  );
}
